export default "/cbETH-WETH-BPT.aacfad6dd3824660004a177f28e5e04f.png";